import { render, staticRenderFns } from "./bind_home.vue?vue&type=template&id=495dbba2&scoped=true&"
import script from "./bind_home.vue?vue&type=script&lang=js&"
export * from "./bind_home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495dbba2",
  null
  
)

export default component.exports